<template>
    <header>
        <span class="btn" @click="router.back()"><van-icon name="arrow-left" size="20" /></span>
        <div class="input">
            <input type="text" v-model="searchValue" @change="changeTab(currentTab)" placeholder="请输入文章关键词搜索您需要的内容" />
            <img src="@/assets/imgs/icon16.png" />
        </div>
    </header>
    <div class="tabbar">
        <span :class="{ active: currentTab == 1 }" @click="changeTab(1)">鉴赏要闻</span>
        <span :class="{ active: currentTab == 2 }" @click="changeTab(2)">文物专题</span>
        <span :class="{ active: currentTab == 3 }" @click="changeTab(3)">人物专题</span>
        <span :class="{ active: currentTab == 4 }" @click="changeTab(4)">资讯杂谈</span>
    </div>

    <div class="news">
        <van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了" @load="fetchList" :offset="100">
            <NewsItem  v-for="item in newsList" :data="item"/>
            <!-- <div class="news_item">
                <div :style="{ backgroundImage: `url(${item.bannerUrl})` }" class="banner_img"></div>
                <div class="content">
                    <h5>{{ item.artName }}</h5>
                    <p>{{ richTextToPlainText(item.introduction) }}</p>
                    <div class="icons">
                        <img src="@/assets/imgs/icon5.png" alt=""> {{ item.browseCount }}
                        <img src="@/assets/imgs/icon6.png" alt=""> {{ item.thumbsUpCount }}
                    </div>
                </div>
            </div> -->
        </van-list>
    </div>
</template>
<script setup>
import { onMounted, ref } from 'vue';
import { http } from '@/request/front'
import NewsItem from '@/views/front/components/NewsItem.vue'
import { useRoute, useRouter } from 'vue-router'
const route = useRoute(), router = useRouter()
const currentTab = ref(1) 
function changeTab(index) {
    finished.value = false
    currentTab.value = index
    newsList.value = []
    pageNo.value = 1
    fetchList()
}
const pageNo = ref(1)
const pageSize = 10
const finished = ref(false)
const loading = ref(false)
const newsList = ref([])
const searchValue = ref('')
function fetchList() {
    loading.value = true
    http.get(`/pc/appreciation/home/list?page=${pageNo.value}&limit=${pageSize}&status=1&type=${currentTab.value}&time=1&artName=${searchValue.value}`).then(res => {
        pageNo.value ++
        loading.value = false
        newsList.value.push(...res.data.rows)
        finished.value = newsList.value.length >= res.data.total
    })
}

onMounted(() => {
    currentTab.value = route.query.type
    fetchList()
})
</script>

<style scoped lang="scss">
header {
    display: flex;
    align-items: center;
    height: 60rem;
    justify-content: space-between;
    padding: 0 20rem;

    .btn {
        width: 40rem;
        height: 40rem;
        display: block;
        text-align: center;
        line-height: 40rem;
    }

    .input {
        width: 80%;
        display: flex;
        align-items: center;

        input {
            width: 100%;
            font-size: 12rem;
        }

        input::placeholder {
            color: #D8D8D8;
        }

        img {
            width: 30rem;
            height: 30rem;
        }
    }
}

.tabbar {
    display: flex;
    border-bottom: 1px solid #F0F0F0;
    margin: 0 20rem;

    span {
        display: block;
        width: 25%;
        text-align: center;
        line-height: 40rem;
        height: 40rem;
        color: #9D9D9D;
    }

    .active {
        color: #000;
        border-bottom: 1px solid #000;
    }
}

.news {
    padding-top: 20rem;

}
</style>